<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.60112 9.01014C3.9547 8.617 4.52796 8.617 4.88153 9.01014L8.72277 13.2812C9.07635 13.6744 9.07635 14.3118 8.72277 14.7049C8.36919 15.098 7.79593 15.098 7.44236 14.7049L3.60112 10.4338C3.24754 10.0407 3.24754 9.40328 3.60112 9.01014Z"
      :fill="color"
    />
    <path
      d="M7.4412 14.705C7.08762 14.3119 7.08762 13.6745 7.4412 13.2813L15.1237 4.73919C15.4773 4.34605 16.0505 4.34605 16.4041 4.73919C16.7577 5.13233 16.7577 5.76974 16.4041 6.16288L8.72161 14.705C8.36804 15.0982 7.79478 15.0982 7.4412 14.705Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "SuccessSmallIcon",
  props: {
    color: {
      default: "#F18E35",
    },
  },
};
</script>

<style scoped></style>
